import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { RewardType } from 'root/src/shared/rewards/constants';
export const deleteRewardEndpoint = {
    authentication: authenticationTypes.authenticated,
    authenticationRole: userGroups.admin,
    endpointType: otherEndpointType,
    payloadSchema: {
        type: 'object',
        properties: {
            brandId: { type: 'string' },
            id: { type: 'string' },
            type: {
                type: 'string',
                enum: [
                    RewardType.KEY,
                    RewardType.CODE,
                    RewardType.BUNDLE,
                ],
            },
        },
        required: ['id', 'type', 'brandId'],
        additionalProperties: false,
    },
};
